import { useQuery } from "react-query";
import { GET_DRUG_CRIMINAL_HISTORY, STALE_TIME_5_MINUTES } from "@constants/reactQueryKeys";
import { getDrugCriminalHistory } from "api/customers";

const useGetDrugCriminalHistory = (clientId: number | null) => {
  const { data, isLoading, refetch, ...rest } = useQuery(
    [GET_DRUG_CRIMINAL_HISTORY, clientId],
    () => getDrugCriminalHistory(clientId),
    {
      staleTime: STALE_TIME_5_MINUTES,
      enabled: Boolean(clientId),
      refetchOnWindowFocus: false,
    }
  );

  return {
    drugCriminalHistory: data?.data || null,
    drugCriminalHistoryLoading: isLoading,
    refetchDrugCriminalHistory: refetch,
    ...rest,
  };
};

export default useGetDrugCriminalHistory;
